// @ts-nocheck
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import getCanOnlyOrderSample from "@store/Framework/Common/Utilities/samples/getCanOnlyOrderSample";
import { HasSampleModelParameter } from "@store/Framework/Common/Utilities/samples/getHasSample";
import getSampleProductInfo from "@store/Framework/Common/Utilities/samples/getSampleProductInfo";

const getSampleProductInfoIfNeeded = (
    state: ApplicationState,
    model: HasSampleModelParameter,
    productInfo: ProductInfo | undefined,
) => {
    if (productInfo && getCanOnlyOrderSample(state, model)) {
        return getSampleProductInfo(productInfo);
    }

    return productInfo;
};

export default getSampleProductInfoIfNeeded;
